import { Badge, Link, useTheme } from "@mui/material";
import React from "react";
import { ThemeColors } from "Theme/AppTheme";
import hexToRGB from "utils/hexToRGB";
import NavigationStore, { IItemOptions, INavigation } from "./NavigationStore";
import { observer } from "mobx-react";

export default observer(function NavigationLink(props: {
    val: INavigation;
    store: NavigationStore;
    handleNavItemClick: (props: INavigation) => void;
    itemOptions?: IItemOptions;
}) {
    const theme = useTheme();
    const currentNavLink = props.store.currentNavItem?.link === props.val.link;

    // Inline style objects for each style
    const itemLinkContainerStyle = {
        paddingLeft: "6px",
        marginLeft: "8px",
        paddingRight: "6px",
        fontSize: "16px",
        minHeight: "24px",
    };
    const curItemContainerStyle = {
        borderRadius: "5px",
        backgroundColor: hexToRGB(ThemeColors.blue, 0.1),
    };
    const itemContainerStyle = {
        width: "100%",
        paddingLeft: "6px",
        display: "flex",
        justifyContent: "left",
        alignItems: "center",
        minHeight: "32px",
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    };
    const denseItemContainerStyle = {
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
    };
    const spreadItemContainerStyle = {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
    };
    const curItemLinkStyle = {
        color: ThemeColors.blue,
        fontWeight: "bold",
        textAlign: "left" as const,
    };
    const itemLinkStyle = {
        color: hexToRGB(ThemeColors.black, 0.5),
    };
    const iconContainerStyle = {
        opacity: 0.5,
    };

    // Compose container style
    let containerStyle = { ...itemContainerStyle };
    if (props.store.currentNavItem?.link === props.val.link) {
        containerStyle = { ...containerStyle, ...curItemContainerStyle };
    }
    if (props.itemOptions?.itemSpacing === "spread") {
        containerStyle = { ...containerStyle, ...spreadItemContainerStyle };
    }
    if (props.itemOptions?.itemSpacing === "dense") {
        containerStyle = { ...containerStyle, ...denseItemContainerStyle };
    }

    return (
        <div key={`config-links-${props.val.title}`} style={containerStyle}>
            <div
                style={{
                    float: "left",
                    height: "24px",
                    width: "24px",
                    display: "flex",
                    alignItems: "center",
                    ...(props.store.currentNavItem?.link !== props.val.link
                        ? iconContainerStyle
                        : {}),
                }}
            >
                {props.val.badgeContent ? (
                    <Badge
                        max={9999}
                        color="error"
                        overlap="rectangular"
                        badgeContent={props.val.badgeContent}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        {...props.val.badgeOptions}
                    >
                        <>
                            {props.store.currentNavItem?.link ===
                                props.val.link && props.val.selectedIcon
                                ? props.val.selectedIcon
                                : props.val.icon}
                        </>
                    </Badge>
                ) : props.store.currentNavItem?.link === props.val.link &&
                  props.val.selectedIcon ? (
                    props.val.selectedIcon
                ) : (
                    props.val.icon
                )}
            </div>
            <div
                key={`link-container-${props.val.title}`}
                style={itemLinkContainerStyle}
            >
                <Link
                    variant="body1"
                    key={`navigation-item-${props.val.title}`}
                    style={{
                        textAlign: "left",
                        fontSize: props.itemOptions?.linkFontSize ?? "16px",
                        fontWeight: currentNavLink ? "bold" : "normal",
                        ...(props.store.currentNavItem?.link !== props.val.link
                            ? itemLinkStyle
                            : curItemLinkStyle),
                    }}
                    underline="none"
                    color="textPrimary"
                    component="button"
                    onClick={() => props.handleNavItemClick(props.val)}
                >
                    {props.val.title}
                </Link>
            </div>
        </div>
    );
});
